<template>
  <div v-if="showLogo" :class="['campaign-box-consumer-test-logo', alignment]">
    <img :src="logo" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ConsumerTestLogo',
  props: {
    logo: {
      type: String,
      default() {
        return '';
      }
    },
    leftAlignment: {
      type: Boolean,
      default() {
        return true;
      }
    }
  },
  computed: {
    showLogo() {
      return this.logo !== '';
    },
    alignment(): string {
      return this.leftAlignment ? 'left' : 'right';
    }
  }
});
</script>

<style lang="scss" scoped>
@import 'src/styles/all';

.campaign-box-consumer-test-logo {
  width: rem-calc(110);
  position: absolute;

  &.left {
    bottom: rem-calc(20);
    left: rem-calc(20);
  }

  &.right {
    bottom: rem-calc(20);
    right: rem-calc(20);
  }

  @media #{$large-up} {
    width: rem-calc(130);

    &.left {
      top: rem-calc(20);
    }

    &.right {
      top: rem-calc(20);
    }
  }
}
</style>
